import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { redpacketPacketsDataProvider } from './dataProvider';

export function initSocialTradingRedpacketPacketsDataProvider() {
  registerModuleDataProvider(Resources.socialTradingRedpacketPackets, redpacketPacketsDataProvider);
}

initSocialTradingRedpacketPacketsDataProvider();
